import { render, staticRenderFns } from "./GuestItem.vue?vue&type=template&id=195b18b2&scoped=true"
import script from "./GuestItem.vue?vue&type=script&lang=js"
export * from "./GuestItem.vue?vue&type=script&lang=js"
import style0 from "./GuestItem.vue?vue&type=style&index=0&id=195b18b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195b18b2",
  null
  
)

export default component.exports